<template>
  <button
    type="button"
    class="pointer-events-auto flex h-5 w-5 cursor-pointer items-center justify-center opacity-50 hover:opacity-100"
    v-tooltip="$t('W: Indsæt tilfældig adresse')"
    @click="onClick">
    <IconLucideSparkles class="h-5 w-5" />
  </button>
</template>

<script lang="ts">
import { pickMagicAddress } from '@/dev/magicAddress'

// Dev/localhost-only: the parent gates the `#trailingIcon` slot it sits in on
// canUseMagicAddress(), the same way the emulator's dummy-email button is gated.
export default {
  name: 'MagicAddressButton',
  emits: ['on-fill'],
  props: {
    currentAddressLine: { type: String, default: '' },
  },
  methods: {
    onClick() {
      this.$emit('on-fill', pickMagicAddress(this.currentAddressLine))
    },
  },
}
</script>
